<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="autoPriceGradeSetForm" :model="autoPriceGradeSetForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="商户">
              <el-select
                clearable
                v-model="autoPriceGradeSetForm.merchantId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="autoPriceGradeSetForm.categoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
           <el-form-item label="年代" prop="machineYearId">
              <el-select v-model="autoPriceGradeSetForm.machineYearId">
                <el-option
                  v-for="item in machineYearConfigList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="类型">
              <el-select
                clearable
                v-model="autoPriceGradeSetForm.type"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in deductionOptionTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getAutoPriceDeductionOptionList">查询</el-button>
            <el-button type="primary" @click="addAutoPriceDeductionOption">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="merchantName"
            label="商户">
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="brandName"
            label="品牌">
          </el-table-column>
          <el-table-column
            prop="machineYearName"
            label="年代">
          </el-table-column>
          <el-table-column
            prop="modelIdListName"
            show-overflow-tooltip
            label="机型">
          </el-table-column>
          <el-table-column
            prop="gradeIdListName"
            show-overflow-tooltip
            label="前端等级区间">
          </el-table-column>
          <el-table-column
            prop="itemNames"
            label="扣款项">
          </el-table-column>
          <el-table-column
            prop="itemValueNames"
            label="扣款值">
          </el-table-column>
           <el-table-column
            prop="deductionOptionType"
            label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.deductionOptionType === 0">自动出价</span>
              <span v-else>AI出价</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">已启用</span>
              <span v-else>已关闭</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorAutoPriceDeductionOption(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="open(scope.row.id)" type="text" size="small" v-if="scope.row.status === 1">开启</el-button>
                <el-button @click="close(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                <el-button @click="deleteAutoPriceDeductionOption(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑自动出价等级规则' : '新建自动出价等级规则'" :visible.sync="isDlg" width="900px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editAutoPriceGradeSetForm" :model="editAutoPriceGradeSetForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editAutoPriceGradeSetForm.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="商户">
              <el-select clearable
                v-model="editAutoPriceGradeSetForm.merchantId"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword>
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select v-model="editAutoPriceGradeSetForm.categoryId" @change="getGradeList(true)">
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="brandId">
              <el-select
                    v-model="editAutoPriceGradeSetForm.brandId"
                  >
                    <el-option
                      v-for="item in brandOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="年代" prop="machineYearId">
              <el-select v-model="editAutoPriceGradeSetForm.machineYearId" @change="changeItemOption()">
                <el-option
                  v-for="item in machineYearConfigList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型" prop="tempModelIdList">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="tempModelIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in modelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="前端等级区间" prop="tempGradeIdList">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="tempGradeIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in queryGradeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
            <el-form-item
              label="扣款评估项目"
              prop="itemIdList"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="itemIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    @change="getSelectItem(itemIdList)"
                  >
                    <el-option
                      v-for="item in functionConditionValues"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
             </el-row>
            </el-form-item>

            <el-form-item
              label="扣款选项"
              prop="itemValueIdList"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="itemValueIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in itemValueOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
             </el-row>
            </el-form-item>

            <el-form-item
              label="类型"
              prop="deductionOptionType"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                <el-radio v-model="editAutoPriceGradeSetForm.deductionOptionType" :label="0">自动出价</el-radio>
                <el-radio v-model="editAutoPriceGradeSetForm.deductionOptionType" :label="1">AI出价</el-radio>
               </el-col>
             </el-row>
            </el-form-item>

          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      dispatchOrderRoleTypeList:[{'id':1,'name':'报价员'},{'id':2,'name':'机器人'}],
      deductionOptionTypeList:[{'id':0,'name':'自动出价'},{'id':1,'name':'AI出价'}],
      // 查询数据
      autoPriceGradeSetForm: {
        categoryId: null
      },
      categoryOptions: [],

      itemIdList:[],

      editItemIdList: [],

      itemValueIdList:[],

      editItemValueIdList: [],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      tempGradeIdList:[],
      tempModelIdList:[],

      // 新建编辑对话框数据

      isDlg: false,
      editAutoPriceGradeSetForm: {
        id: null,
        categoryId: null,
        gradeIdList: [],
        autoPriceGradeId: null
      },

      editorFormRules: {
        categoryId: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
        // tempGradeIdList: [
        //   { required: true, message: '请选择前端等级', trigger: 'change' },
        // ],
      },
      dlgType: 'change',
      queryGradeList:[],
      brandOptions:[],
      modelList:[],
      merchatOptions:[],
       //评估项目和值
      functionConditionValues: [],
      itemValueOptions: [],
      machineYearConfigList:[],
    }
  },
  watch:{},
  computed:{},
  methods:{
     // 请求几代机配置
     getMachineYearConfigList(param) {
      let self = this;
      self.$api.listMachineYearConfig().then(res => {
        if(res.code === 200) {
          self.machineYearConfigList = res.data || []
        }
      
      })
    },
    // 获取评估项目选项和值
    getEavlItemOptions(isEdit, itemIdList) {
      if (this.editAutoPriceGradeSetForm.categoryId === "") {
        return;
      }
      let self = this;
      self.$api
        .getEvaluationOptions({
          categoryId: self.editAutoPriceGradeSetForm.categoryId,
          brandId: self.editAutoPriceGradeSetForm.brandId,
          typeKey:
            "evaluate_condition,evaluate_function,evaluate_value,sku_small_model,sku_network,sku_warranty_duration,sku_body_color,sku_purchase_channel,category",
        })
        .then((res) => {
          if (res.code === 200) {
            self.functionConditionValues = res.data;
            if (isEdit) {
              self.getSelectItem(itemIdList);
            }
          }
        });
    },
     //选中评估项，更新评估项选项值
     getSelectItem(values) {
      let self = this;
      self.$set(self.editAutoPriceGradeSetForm, "itemIdList", values);
      if (values === "") {
        this.editAutoPriceGradeSetForm.itemValueId = null;
        this.$set(this, "itemValueOptions", []);
        return;
      }
      this.itemValueOptions = [];
      for (
        let index = 0;
        index < this.functionConditionValues.length;
        index++
      ) {
        let item = this.functionConditionValues[index];
        if(values.includes(item.id)){
          this.itemValueOptions = this.itemValueOptions.concat(item.children);
        }
      }
    },
     // 请求商户列表
     getMerchantList(param) {
      let self = this;
      self.$api.getMerchantList({
        merchantLike: param,
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.merchatOptions = res.data.records
          self.merchatOptions.unshift({'id':0,'name':'通用'})
        }
      
      })
    },

    changeItemOption(){
      this.getModelListByBrandIds()
      this.getEavlItemOptions(false,[])
    },
            //获取品牌下的sku信息
    getModelListByBrandIds() {
       let self = this;
       let machineYearConfig = null;
       for(var i = 0;i<self.machineYearConfigList.length;i++){
         let temp = self.machineYearConfigList[i]
         if(temp.id==self.editAutoPriceGradeSetForm.machineYearId){
           machineYearConfig = temp;
           break;
         }
       }

      self.$api
        .getModelListByBrandIds({
          brandIds: [self.editAutoPriceGradeSetForm.brandId],
          startYear: machineYearConfig==null?null:machineYearConfig.startYear,
          endYear: machineYearConfig==null?null:machineYearConfig.endYear
        })
        .then((res) => {
          self.modelList = res.data;
          self.modelList.unshift({'id':0,'name':'通用'})
        });
    },
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
            // if(optionName=='brandOptions'){
            //   self[optionName].unshift({'id':0,'name':'通用'})
            // }
          }
        });
    },
    deleteAutoPriceDeductionOption(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteAutoPriceDeductionOption({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getAutoPriceDeductionOptionList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getAutoPriceDeductionOptionList()
    }, 
    //等级
    getGradeList(val) {
      let self = this;
        this.$api
            .getValidModelGrade({
              categoryId: self.editAutoPriceGradeSetForm.categoryId,
            })
            .then((res) => {
              self.queryGradeList = res.data || [];
             
            });
          if(val){
            self.tempGradeIdList=[];
            self.tempBrandIdList=[];
            self.tempModelIdList=[];
            self.editAutoPriceGradeSetForm.autoPriceGradeId=null;
          }
          self.getSelectOptions(
                    'phoneBrand',
                    'brandOptions',
                    self.editAutoPriceGradeSetForm.categoryId
                  ); 
    },

    // 获取门店列表
    getAutoPriceDeductionOptionList() {
      let self  = this;
      self.$api.listSearchAutoPriceDeductionOption({
        page: self.currentPage,
        size: self.pageSize,
        merchantId: self.autoPriceGradeSetForm.merchantId,
        categoryId: self.autoPriceGradeSetForm.categoryId || null,
        type: self.autoPriceGradeSetForm.type,
        machineYearId:self.autoPriceGradeSetForm.machineYearId|| null
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加门店
    addAutoPriceDeductionOption() {
      this.dlgType = 'new'
      this.tempGradeIdList=[];
      this.tempBrandIdList=[]
      this.tempModelIdList=[]
      this.itemIdList=[]
      this.itemValueIdList=[]
      this.editAutoPriceGradeSetForm =  {
        id: null,
        merchantId:null,
        categoryId: null,
        gradeIdList: [],
        brandId:null,
        modelIdList:[],
        deductionOptionType:0
      }
      this.$nextTick(()=>{
          this.$refs['editAutoPriceGradeSetForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改门店
    editorAutoPriceDeductionOption(row) {
      let self = this;
      self.editAutoPriceGradeSetForm=JSON.parse(JSON.stringify(row));
      self.getGradeList(false);
      self.tempGradeIdList = JSON.parse(self.editAutoPriceGradeSetForm.gradeIdList)
      self.tempModelIdList = JSON.parse(self.editAutoPriceGradeSetForm.modelIdList)
      self.itemIdList= JSON.parse(self.editAutoPriceGradeSetForm.itemIds)
      self.itemValueIdList= JSON.parse(self.editAutoPriceGradeSetForm.itemValueIds)
      self.getModelListByBrandIds()
      this.getEavlItemOptions(true,self.itemIdList)
      console.log(row)
      self.dlgType = 'change'
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editAutoPriceGradeSetForm'].validate((valid) => {
        if (valid) {
          self.editAutoPriceGradeSetForm.gradeIdList=JSON.stringify(self.tempGradeIdList);
          self.editAutoPriceGradeSetForm.modelIdList=JSON.stringify(self.tempModelIdList);

          let itemNameList = [];
          for (let i = 0; i < this.itemIdList.length; i++) {
            const itemId = this.itemIdList[i];
            const item = this.functionConditionValues.find(option => option.id === itemId);
            if (item) {
              itemNameList.push(item.name);
            }
          }

          let itemValueNameList = [];
          for (let i = 0; i < this.itemValueIdList.length; i++) {
            const itemId = this.itemValueIdList[i];
            const item = this.itemValueOptions.find(option => option.id === itemId);
            if (item) {
              itemValueNameList.push(item.name);
            }
          }
          let itemValueCodeList = [];
          for (let i = 0; i < this.itemValueIdList.length; i++) {
            const itemId = this.itemValueIdList[i];
            const item = this.itemValueOptions.find(option => option.id === itemId);
            if (item) {
              itemValueCodeList.push(item.value);
            }
          }
          self.editAutoPriceGradeSetForm.itemIds = JSON.stringify(self.itemIdList);
          self.editAutoPriceGradeSetForm.itemNames = itemNameList.join(",");
          self.editAutoPriceGradeSetForm.itemValueIds = JSON.stringify(self.itemValueIdList);
          self.editAutoPriceGradeSetForm.itemValueCodes = JSON.stringify(itemValueCodeList);
          self.editAutoPriceGradeSetForm.itemValueNames = itemValueNameList.join(",");

          if(self.dlgType === 'change') {
            self.$api.updateAutoPriceDeductionOption(self.editAutoPriceGradeSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getAutoPriceDeductionOptionList()
                this.closeEditorDlg()
              }
            })
          } else {
            self.$api.addAutoPriceDeductionOption(self.editAutoPriceGradeSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getAutoPriceDeductionOptionList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    //获取等级名称
    getGradeName(gradeId){
      for(var i=0;i<this.queryGradeList.length;i++){
        if(gradeId==this.queryGradeList[i].id){
          return this.queryGradeList[i].name
        }
      }
      return ""
    },
      //获取等级名称
      getDispatchOrderWayTypeName(id){
      for(var i=0;i<this.dispatchOrderRoleTypeList.length;i++){
        if(id==this.dispatchOrderRoleTypeList[i].id){
          return this.dispatchOrderRoleTypeList[i].name
        }
      }
      return ""
    },

    // 开启门店
    open(id) {
      let self = this
      this.$api.openAutoPriceDeductionOption(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          self.getAutoPriceDeductionOptionList()
        }
      })
    },

    // 关闭门店
    close(id) {
      let self = this
      this.$api.closeAutoPriceDeductionOption(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          self.getAutoPriceDeductionOptionList()
        }
      })
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getAutoPriceDeductionOptionList();
    self.getSelectOptions("category", "categoryOptions");
    self.getMerchantList();
     self.getMachineYearConfigList()
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>